module.exports = function() {
  return new Worker(__webpack_public_path__ + "01134e08b5ee208ab31d.worker.js");
};